import * as React from 'react';
import withStyles, {
  WithStyles,
  StyleRules,
  ClassNameMap
} from '@material-ui/core/styles/withStyles';
import {Theme} from '@material-ui/core/styles';
import {IconButton} from '@material-ui/core';
import {Select, MenuItem} from '@material-ui/core';
import {Toolbar, Typography} from '@material-ui/core';
// import TablePaginationActions from '@material-ui/core/TablePaginationActions';
import TablePagination from '@material-ui/core/TablePagination';
// import { ActionsComponent} from `@material-ui/core/TablePagination`

const styles = (theme: Theme): StyleRules => ({
  container: {
    fontSize: '0.75rem'
  },
  pager: {
    display: 'flex',
    flexDirection: 'row-reverse'
  },
  spacer: {
    width: 15 
  },
  toolbar: {
    justifyContent:"flex-end"
  },
  formField: {
    width: '100%'
  },
  /* Styles applied to the Select component `root` class. */
  selectRoot: {
    fontSize: theme.typography.pxToRem(12),
    paddingRight: 10,
    paddingLeft: 10,
    color: theme.palette.text.secondary
  },

  /* Styles applied to the Select component `select` class. */
  select: {
    paddingLeft: 8,
    paddingRight: 12,
  },

  /* Styles applied to the Select component `icon` class. */
  selectIcon: {
    top: 1
  }
});

// BEFORE YOU ADD PROPS HERE:  Please consider that this is a HELPER to use when building forms where the Primary considerations are the contents of the form definition
// Please consider whther adding a property here is really necessary, or wether it belongs as part of the form definition, itself, or whether you should really be using
// one of the underlying controls directly.
interface Props {
  /**
   * The total number of rows.
   */
  count: number;

  /**
   * The zero-based index of the current page.
   */
  page: number;

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback
   * @param {number} page The page selected
   */
  onChangePage: Function;

  /**
   * Callback fired when the number of rows per page is changed.
   *
   * @param {object} event The event source of the callback
   */
  onChangeRowsPerPage?: Function;

  /**
   * The number of rows per page.
   */
  pageSize?: number;

  /**
   * Customizes the options of the rows per page select field. If less than two options are
   * available, no select field will be displayed. options should use {label: '', value: 5} label value object.
   */
  pageSizeOptions?: Array<object>;

  /**
   * Customize the rows per page label. Invoked with a `{ from, to, count, page }`
   * object.
   */
  labelPageSize?: (object) => any;

  /**
   * Customize how the paging positioning display (eg. Page x of t (z items))
   */
  labelDisplayedItems?: (
    fromIdx: number,
    toIdx: number,
    count: number,
    page: number
  ) => any;

  /**
   * Properties applied to the next arrow [`IconButton`](/api/icon-button) element.
   */
  nextIconButtonProps?: object;

  /**
   * Properties applied to the back arrow [`IconButton`](/api/icon-button) component.
   */
  backIconButtonProps?: object;

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css-api) below for more details.
   */
  classes?: ClassNameMap;
  /**
   * If true, the scroll to top button will be hidden
   */
   disallowScrollTop?: boolean
}

type State = {
  fromIdx: number;
  toIdx: number;
  pageSizeOptions: Array<object> | null;
};

const defaultPageSizeOptions: Array<any> = [10,25,50,100]

class Pager extends React.Component<
  Props & WithStyles<keyof typeof styles>,
  State
> {
  constructor(props: Props & WithStyles<keyof typeof styles>) {
    super(props, {});
    this.state = this.deriveStateFromProps(props);
  }

  UNSAFE_componentWillReceiveProps(newProps: Props & WithStyles<keyof typeof styles>) {
    this.setState(this.deriveStateFromProps(newProps));
  }

  deriveStateFromProps = (
    newProps: Props & WithStyles<keyof typeof styles>
  ): State => {
    var pageSize: number = newProps.pageSize || 10;
    var page: number = newProps.page || 0;
    var count: number = this.props.count || 0;
    var fromIdx: number = (page) * pageSize;
    var toIdx: number = fromIdx + pageSize - 1;
    if (toIdx >= count) {
      toIdx = count - 1;
    }

    const state: State = {
      fromIdx: fromIdx,
      toIdx: toIdx,
      pageSizeOptions:
        newProps.pageSizeOptions == undefined
          ? defaultPageSizeOptions
          : newProps.pageSizeOptions
    };


    return state;
  };

  handleChangePage = (evt: any, newPage: number) => {
    this.props.onChangePage(newPage, this.props.pageSize);

  };

  handleChangePageSize = (evt: any) => {
    this.props.onChangePage(this.props.page, evt.target.value);
  };

  defaultLabelDisplayedItems = (
    fromIdx: number,
    toIdx: number,
    itemCount: number,
    page: number
  ): any => {
    return (
      <Typography variant="caption">{`Showing ${fromIdx + 1} to ${toIdx +
        1} of ${itemCount}`}</Typography>
    );
  };

  render() {
    const {classes}: {classes: ClassNameMap} = this.props;
    const {
      page,
      pageSize,
      count,
      labelPageSize,
      labelDisplayedItems
    } = this.props;
    const {fromIdx, toIdx, pageSizeOptions} = this.state;

    var lps: any = 'Items per page';
    if (labelPageSize) {
      lps = labelPageSize({});
    }

    var display: any = this.defaultLabelDisplayedItems(
      fromIdx,
      toIdx,
      count,
      page
    );

    if (labelDisplayedItems) {
      display = labelDisplayedItems(fromIdx, toIdx, count, page);
    }

    return (
      <div className={classes.container}>
        <Toolbar className={classes.toolbar}>
          <div className={classes.spacer}></div>
          <div className={classes.spacer}></div>
          <div className={classes.spacer}></div>
          <table border={0}>
            <tbody>
              <tr>
                <TablePagination
                  className={classes.actions}
                  count={count}
                  onChangePage={this.handleChangePage}
                  onChangeRowsPerPage={this.handleChangePageSize}
                  labelRowsPerPage={lps}
                  page={page}
                  rowsPerPage={pageSize || 10}
                  rowsPerPageOptions={pageSizeOptions}
                />
                {!this.props.disallowScrollTop && <IconButton style={{marginTop: 27}} onClick={()=>{
                  window.scrollTo(0,0)
                }}>
                  <i style={{fontSize: 'small'}} title="Scroll to top" className="fa fa-xs fa-chevron-double-up"  />
                </IconButton>}
              </tr>
            </tbody>
          </table>
        </Toolbar>
      </div>
    );
  }
}

export default withStyles(styles)(Pager);
